import { render } from "./RensponsiveGallerySmallScreen.vue?vue&type=template&id=3c25189c"
import script from "./RensponsiveGallerySmallScreen.vue?vue&type=script&lang=js"
export * from "./RensponsiveGallerySmallScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__